import React, { Component } from 'react'
import FacebookRegistrationButton from './FacebookRegistrationButton'
import GoogleRegistrationButton from './GoogleRegistrationButton'
import EmailRegistrationForm from './EmailRegistrationForm'

export default class Step1 extends Component {

  render() {
    const { loading, onSubmit, errors } = this.props

    return (
      <div className="signup__form signup__form__step1">
        <div>
          <div className="social__button__wrapper">
            <FacebookRegistrationButton {...this.props} />
            <GoogleRegistrationButton {...this.props} />
          </div>

          <div className="signup__form__or hide-on-mobile">
            or register by email
          </div>

          <div className="signup__form__or show-on-mobile-only">
            or
          </div>
        </div>

        <div>
          <form>
            <h3>Create Your Account</h3>

            { errors.base && <div className="base-errors">{ errors.base }</div> }

            <EmailRegistrationForm {...this.props} />

            <div style={{width: "100%", textAlign: "center"}}>
              <input type="submit" value="Next" onClick={onSubmit} disabled={loading} className={`next__button ${loading ? 'loading' : ''}`} />
            </div>
          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SignupWidget/Step1.js